import { formatDistanceToNow, type Locale } from 'date-fns';
import { de, enUS, fr, hu } from 'date-fns/locale';
import type { supportedLanguages } from '@/i18n/locales';

const DATE_FNS_LOCALES: Partial<Record<string, Locale>> = {
  de,
  en: enUS,
  fr,
  hu
} satisfies Record<(typeof supportedLanguages)[number], Locale>;

export function formatRelativeTime(date: Date | number, language: string): string {
  return formatDistanceToNow(date, { addSuffix: true, locale: DATE_FNS_LOCALES[language] });
}
